var map = {
	"./black/0-5_HSR_Icon.png": [
		484,
		484
	],
	"./black/1-0_HSR_Icon.png": [
		1572,
		1572
	],
	"./black/1-5_HSR_Icon.png": [
		263,
		263
	],
	"./black/2-0_HSR_Icon.png": [
		2797,
		2797
	],
	"./black/2-5_HSR_Icon.png": [
		8034,
		8034
	],
	"./black/3-0_HSR_Icon.png": [
		5218,
		5218
	],
	"./black/3-5_HSR_Icon.png": [
		8765,
		8765
	],
	"./black/4-0_HSR_Icon.png": [
		1803,
		1803
	],
	"./black/4-5_HSR_Icon.png": [
		608,
		608
	],
	"./black/5-0_HSR_Icon.png": [
		8920,
		8920
	],
	"./green/0-5_HSR_Icon.png": [
		6964,
		6964
	],
	"./green/1-0_HSR_Icon.png": [
		5892,
		5892
	],
	"./green/1-5_HSR_Icon.png": [
		6631,
		6631
	],
	"./green/2-0_HSR_Icon.png": [
		7853,
		7853
	],
	"./green/2-5_HSR_Icon.png": [
		5890,
		5890
	],
	"./green/3-0_HSR_Icon.png": [
		4130,
		4130
	],
	"./green/3-5_HSR_Icon.png": [
		6269,
		6269
	],
	"./green/4-0_HSR_Icon.png": [
		2027,
		2027
	],
	"./green/4-5_HSR_Icon.png": [
		8544,
		8544
	],
	"./green/5-0_HSR_Icon.png": [
		2888,
		2888
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4405;
module.exports = webpackAsyncContext;